module.exports = __webpack_public_path__ + "img/logo.123050fa.svg";